// extracted by mini-css-extract-plugin
module.exports = {"PreloaderText":"proloader_text_PreloaderText__3nMTc","slideText":"proloader_text_slideText__HXdHC"};